<!-- 系统订单-按人 -->

<template>
  <div class="by-person-dialog">
    <w-dialog ref="dialogRef" class="by-person" title="接单确认" width="60%" top="10vh" confirmText="确认接单"
      @wConfirm="handleSure">
      <el-form class="add-form" ref="formRef" :model="ruleForm" :rules="rules" labelPosition="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="乘车人数" prop="count">
              <el-input v-model="ruleForm.count" type="number" placeholder="请输入乘车人数" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接单车辆信息" prop="car_id">
              <el-select v-model="ruleForm.car_id" placeholder="请选择" filterable @change="carChange">
                <el-option v-for="(item, i) in carOptions" :key="i" :label="item.plate" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发车时间" prop="departure_time">
              <!-- <el-date-picker v-model="ruleForm.departure_time" type="datetime" placeholder="请选择发车时间"
                format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable
                :disabled-date="departDisabledDate" /> -->
              <el-col :span="12" style="padding: 0;width: 100%;">
                <el-date-picker v-model="ruleForm.departDate" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                  placeholder="请选择日期" disabled />
              </el-col>
              <el-col :span="12" style="padding-right: 0;width: 100%;">
                <el-time-picker v-model="ruleForm.departTime" format="HH:mm" value-format="HH:mm" placeholder="请选择时间" />
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预计抵达时间" prop="arrival_time">
              <!-- <el-date-picker v-model="ruleForm.arrival_time" type="datetime" placeholder="请选择预计抵达时间"
                format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable
                :disabled-date="departDisabledDate" /> -->
              <el-col :span="12" style="padding: 0;width: 100%;">
                <el-date-picker v-model="ruleForm.arrivalDate" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                  placeholder="请选择日期" disabled style="width: 100%" />
              </el-col>
              <el-col :span="12" style="padding-right: 0;width: 100%;">
                <el-time-picker v-model="ruleForm.arrivalTime" format="HH:mm" value-format="HH:mm" placeholder="请选择时间"
                  style="width: 100%" />
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="剩余座位数" prop="available_count">
              <el-input v-model="ruleForm.available_count" type="number" placeholder="请输入" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机" prop="driver">
              <el-select v-model="ruleForm.driver" :remote-method="getDriverOptions" filterable remote clearable
                placeholder="请选择司机" :loading="isLoading">
                <el-option v-for="item in driverOptions" :key="item.u_id" :label="item.u_name" :value="item.u_id">
                  <el-row>
                    <el-col :span="8">{{ item.u_name }}</el-col>
                    <el-col :span="10">{{ item.u_tel }}</el-col>
                    <el-col :span="6">{{ item.du_name }}</el-col>
                  </el-row>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </w-dialog>
  </div>
</template>

<script>
import { ref, reactive, } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { ElMessage, } from "element-plus";

export default {
  emits: ["submit"],
  components: {},
  setup(props, { emit }) {
    const dialogRef = ref(null);  // 弹框对象
    const carOptions = ref([]); // 车辆
    const driverOptions = ref([]); // 司机列表
    const isLoading = ref(false); // 司机列表加载状态
    const formRef = ref(null);
    const ruleForm = ref({
      order_id: '',  // 订单id
      count: '',  // 乘车人数量
      car_id: '',  // 车辆
      departure_time: '',  // 发车时间
      arrival_time: '',  // 预计抵达时间
      arrivalDate: '',  // 预计抵达日期
      departDate: '',  // 发车日期
      departTime: '',  // 发车时间
      arrivalTime: '',  // 预计抵达时间
      driver: '',  // 司机
      car_records_id: '',  // 车辆记录id
      available_count: '',  // 剩余座位数
    });
    const rules = reactive({
      count: [
        { required: true, message: "请输入乘车人数", trigger: "blur", },
      ],
      car_id: [
        { required: true, message: "请选择司机", trigger: "change", },
      ],
      driver: [
        { required: true, message: "请选择司机", trigger: "change", },
      ],
    });

    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row) => {
      ruleForm.value.order_id = row.or_id;
      ruleForm.value.count = row.oc_number;
      ruleForm.value.car_id = '';
      ruleForm.value.departure_time = '';
      ruleForm.value.arrival_time = '';
      ruleForm.value.departDate = row.oc_subscribe_stime ? new Date(row.oc_subscribe_stime).toISOString().split('T')[0] : '';
      ruleForm.value.departTime = row.oc_subscribe_stime ? new Date(row.oc_subscribe_stime).toTimeString().split(' ')[0].slice(0,-3) : '';
      ruleForm.value.arrivalDate = row.oc_subscribe_etime ? new Date(row.oc_subscribe_etime).toISOString().split('T')[0] : '';
      ruleForm.value.arrivalTime = row.oc_subscribe_etime ? new Date(row.oc_subscribe_etime).toTimeString().split(' ')[0].slice(0,-3) : '';
      ruleForm.value.driver = '';
      ruleForm.value.available_count = '';
      ruleForm.value.car_records_id = '';
      driverOptions.value = [];
      getAvailableCarList();
      dialogRef.value.show();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 关闭对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }

    /**
     * 
     * 获取可用车辆列表
     * 
     * **/
    const getAvailableCarList = () => {
      VipApi.getAvailableCarList({ req_type: 1, }).then((res) => {
        if (res.Code == 200) {
          carOptions.value = res.Data;
        }
      });
    }
    /**
     * 
     * 获取司机
     * 
     * **/
    const getDriverOptions = (query) => {
      VipApi.searchCarDiver({ keyword: query, }).then((res) => {
        if (res.Code == 200) {
          driverOptions.value = res.Data;
        }
      });
    }
    /**
     * 
     * 选择车辆
     * 
     * **/
    const carChange = () => {
      const selectedCar = carOptions.value.find(car => car.id === ruleForm.value.car_id);
      if (selectedCar) {
        ruleForm.value.available_count = selectedCar.available_count; // 更新剩余座位数
        ruleForm.value.car_records_id = selectedCar.car_records_id; // 更新车辆记录id
        if (selectedCar.driver_list.length > 0) {
          ruleForm.value.driver = selectedCar.driver_list[0].u_id; // 更新车辆司机列表中的剩余座位数
          getDriverOptions(selectedCar.driver_list[0].u_name);
        }
      } else {
        ruleForm.value.available_count = ''; // 如果没有选中车辆，清空剩余座位数
        ruleForm.value.car_records_id = ''; // 清空车辆记录id
        ruleForm.value.driver = '';
      }
    }
    /**
     * 
     * 禁用日期
     * 
     * **/
    const departDisabledDate = () => {
      return true;
    }
    /**
     * 
     * 禁用过去的日期
     * 
     * **/
    const arriveDisabledDate = (time) => {
      return time.getTime() < Date.now() - 86400000; // Date.now() - 86400000 将当前时间减去一天的毫秒数，确保只能选择今天及以后
    }
    /**
     * 
     * 确认提交
     * 
     * **/
    const handleSure = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          if (ruleForm.value.available_count < ruleForm.value.count) {
            ElMessage.error('剩余座位数不足，请重新选择车辆！');
            return;
          }
          if (!ruleForm.value.departDate) {
            ElMessage.error('请选择发车日期！');
            return;
          }
          if (!ruleForm.value.departTime) {
            ElMessage.error('请选择发车时间！');
            return;
          }
          if (!ruleForm.value.arrivalDate) {
            ElMessage.error('请选择预计抵达日期！');
            return;
          }
          if (!ruleForm.value.arrivalTime) {
            ElMessage.error('请选择预计抵达时间！');
            return;
          }
          ruleForm.value.arrival_time = `${ruleForm.value.arrivalDate} ${ruleForm.value.arrivalTime}`;
          ruleForm.value.departure_time = `${ruleForm.value.departDate} ${ruleForm.value.departTime}`;
          dialogRef.value.isLoading = true;
          emit("submit", ruleForm.value);
        }
      })
    }


    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      formRef,
      ruleForm,
      rules,
      handleSure,
      driverOptions,
      getDriverOptions,
      isLoading,
      departDisabledDate,
      arriveDisabledDate,
      carOptions,
      carChange,
    };
  },
};
</script>

<style lang="scss">
.by-person-dialog {
  .el-autocomplete {
    width: 100%;
  }

  .el-dialog__body {
    height: 400px;

    .el-form-item__content {
      height: 40px;
    }
  }
}
</style>